export default {
  en: {
    RATE_LIMITS_PAGE_TITLE: 'Rate Limits',
    RATE_LIMITS_TABLE_HEADER_NAME: 'Name',
    RATE_LIMITS_TABLE_HEADER_EMAIL: 'Email',
    RATE_LIMITS_TABLE_HEADER_ROLE: 'Role',
    RATE_LIMITS_TABLE_SUBHEADER_PATH_PATTERN: 'Path Pattern',
    RATE_LIMITS_TABLE_SUBHEADER_LIMIT: 'Limit',
    RATE_LIMITS_TABLE_SUBHEADER_METHOD: 'Method',
    RATE_LIMITS_TABLE_SUBHEADER_PERIOD: 'Period',
    RATE_LIMIT_PANE_EMPTY: 'No rate limits have been set up on this account.',
  }
};
